import PhoneIcon from '@mui/icons-material/Phone';
import { Tooltip } from '@mui/material';
import isMobile from '../../hooks/isMobile';
import { SquareIconButton } from '../../utils/exports/Styles';

const AudioCall = () => {
  const mobileView = isMobile();
  return (
    <Tooltip title='Audio Call'>
      <SquareIconButton
        sx={{
          color: 'black',
          width: mobileView ? '20px' : '30px',
          height: mobileView ? '20px' : '30px',
        }}
      >
        <PhoneIcon />
      </SquareIconButton>
    </Tooltip>
  );
};

export default AudioCall;
